import { render, staticRenderFns } from "./contract_upload_truck.vue?vue&type=template&id=4b805d0c&scoped=true&"
import script from "./contract_upload_truck.vue?vue&type=script&lang=js&"
export * from "./contract_upload_truck.vue?vue&type=script&lang=js&"
import style0 from "./contract_upload_truck.vue?vue&type=style&index=0&id=4b805d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b805d0c",
  null
  
)

export default component.exports